var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-none d-md-flex"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_setup.show)?_c(_setup.NftPromotion,{staticClass:"project-nft-promotion",attrs:{"promotion":_setup.promotion},on:{"close":function($event){return _setup.close()}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }